import React, { Component } from 'react';
import { Column, Row } from "@sm/helpers/simple-flexbox";

import ManageClient from '@modules/clients/ManageClient';

class EditClient extends Component {
  state = {};

  render() {
    return <Row flexGrow={ 1 } className='module apidata viewClient overflow-x-auto' vertical='start'>
      <Column flexGrow={ 1 } className='overflow-x-auto'>
        <ManageClient clientId={ this.props.match.params.clientId } viewOrEdit={ 2 }/>
      </Column>
    </Row>;
  }
}

export default EditClient;